import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.4l+0pK',
    defaultMessage: 'Quotas',
  },
  emailTitle: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
});
